import type { MessageDoc } from '../../shared/types';
import { pictureOf } from '../../shared/summary';
import { urlFor, type WithId } from './data';
import { Photo } from './Photo';
import { shownMedia } from '../../shared/constants';

/**
 * The picture of a message quoted somewhere else -- a photo, or a clip's
 * poster (shared/summary.ts) -- small and faded, so it says which photo
 * without competing with what is around it.
 */
export function QuoteThumb({ message, size }: { message: WithId<MessageDoc>; size: number }) {
  const picture = pictureOf(message.data);
  if (!picture) return null;
  return <Photo loading="eager" className="quote-thumb" src={urlFor(shownMedia(picture))} preview={picture.blur} alt="" style={{ width: size, height: size }} />;
}
